export default __webpack_public_path__ + "static/media/house_four.eaa5bd81.jpg";